<template>
  <login-layout>
    <div class="login-main">
      <div class="top-btns"></div>
      <div class="logo"></div>
      <h1>Hi, 热烈欢迎!</h1>
      <p class="title2">登陆并开始管理你的账户</p>
      <div class="divider">
        <span>用户名登录</span>
      </div>
      <div class="form">
        <div class="tip">{{ error }}</div>
        <dl>
          <dt>用户名</dt>
          <dd>
            <el-input class="txt" ref="mobile" v-model="form.mobile" placeholder="请输入用户名"></el-input>
          </dd>
        </dl>
        <dl>
          <dt>密码</dt>
          <dd>
            <el-input class="txt" ref="password" v-model="form.password" :type="viewPwd ? 'input' : 'password'" placeholder="请输入密码"></el-input>
            <img class="mouse eye" @click="viewPwd = !viewPwd" src="../../../../assets/images/eye.png" width="24" height="24px" />
          </dd>
        </dl>
        <p class="forget-pwt">
          <span class="fl">
            <el-checkbox v-model="rememberLoginName">记住我</el-checkbox>
          </span>
        </p>
      </div>
      <div class="button" @click="loginByName">登 录</div>
    </div>
  </login-layout>
</template>
<script>
import LoginLayout from '../../layouts/login.vue'
import Security from '../../ui/security.vue'
import { getAccountRoleType } from '@/service/apis/order'
import { postAccountLogin, getCpaChannelByAccountId } from '@/service/apis/userinfo'

// 随机抽取四位数
const identifyCodes = '1234567890abcdef'
export default {
  components: {
    LoginLayout,
    Security
  },
  inject: [ 'updateGlobalStorage', 'globalStorage' ],
  data () {
    return {
      viewPwd: false,
      identifyCode: '',
      form: {
        mobile: '',
        password: ''
      },
      mobileForm: { // 手机号登录
        mobile: '',
        smdCode: '', // 短信验证码
        picCode: '', // 图形验证码
      },
      totalTime: 60,
      sendCodeTxt: '发送验证码',
      canClick: true,
      error: '',
      rememberLoginName: false // 记住密码
    }
  },
  name: 'login',
  mounted () {
    // 平台类型
    // let type = this.$route.query.type
    // if (['1', '2', '4'].indexOf(type) !== -1) {
    //   this.type = parseInt(type)
    // } else {
    //   this.$router.back()
    // }
    // 记住密码
    let loginName = localStorage.getItem('LOGIN_NAME')
    if (loginName) {
      this.form.mobile = loginName
      this.rememberLoginName = true
    }
    this.identifyCode = ''
    this.makeCode(identifyCodes, 4)
  },
  methods: {
    // 验证码处理
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    // 刷新验证码
    refreshCode() {
      this.identifyCode = ''
      this.makeCode(identifyCodes, 4)
    },
    makeCode (o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += o[
          this.randomNum(0, o.length)
        ]
      }
    },
    // 用户名登录
    loginByName () {
      let form = this.form
      if (!form.mobile) {
        this.error = '请输入账号'
        this.alertError(this.error)
        this.$refs.mobile.focus()
        return false
      } else if (!form.password) {
        this.error = '请输入密码'
        this.alertError(this.error)
        this.$refs.password.focus()
        return false
      }
      this.error = ''
      // 记住用户名
      localStorage.setItem('LOGINNAME', form.mobile)
      if (this.rememberLoginName) {
        localStorage.setItem('LOGIN_NAME', form.mobile)
      }
      postAccountLogin.call(this, {
        loginType: "password",
        ...this.form
      }).then(resp => {
        this.loginSuccess(resp)
        // 获取角色
        this.getAccountRoleType(resp)
        this.getCpaChannelByAccountId(resp)
      })
    },
    getCpaChannelByAccountId (resp = {}) {
      getCpaChannelByAccountId.call(this, {
        qdAccountId: resp.account.id
      }).then(res => {
        localStorage.setItem('ACCOUNT', JSON.stringify(res || {}))
      })
    },
    
    getAccountRoleType (resp = {}) {
      let roleType = ''
      getAccountRoleType.call(this, {
        accountId: resp.account.id
      }).then(res => {
        roleType = res 
      }).finally(() => {
        const account = { 
          ...resp.account,
          roleType 
        }
        localStorage.setItem('ACCOUNT_DTO', JSON.stringify(account))
      })
    },

    loginSuccess (resp) {
      this.$notify({
        title: '提示',
        message: '登录成功',
        type: 'success'
      });
      localStorage.setItem('TOKEN', resp.auth)
      localStorage.setItem('ACCOUNT_DTO', JSON.stringify(resp.account)) 
      
      this.$router.push('/home')
    },
    // 弹出错误
    alertError (err) {
      this.$message.error(err)
    },
  }
}
</script>

<style scoped>
.login-main {
  max-width: 640px;
  position: relative;
}
.login-main .top-btns {
  position: fixed;
  right: 40px;
  top: 40px;
}
.top-btns span {
  margin-left: 16px;
  font-size: 16px;
  font-weight: 500;
  color: #0076F6;
  padding: 0 22px;
  display: inline-block;
  height: 36px;
  line-height: 36px;
  border-radius: 27px;
  border: 2px solid #0076F6;
  cursor: pointer;
}
.login-main h1 {
  height: 40px;
  line-height: 40px;
  font-size: 36px;
  font-weight: 600;
  color: #081735;
}
.login-main .title2 {
  font-size: 18px;
  line-height: 24px;
  color:#999;
  padding: 15px 0 30px 0;
}

.login-main .button {
  cursor: pointer;
  width: 100%;
  height: 54px;
  line-height: 54px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  border-radius: 8px;
  background-color: rgba(0, 118, 246, 1);
  box-shadow: 0 10px 20px #CDD6F0;
}
.login-main .form {
    width: 100%;
    padding-bottom: 32px;
    position: relative;
}
.login-main .form .tip {
  position: absolute;
  left: 0;
  top: -52px;
  font-size: 12px;
  color: #F5222D;
}
.login-main .form dl {
  width: 100%;
  display: block;
  padding-bottom: 24px;
}
.login-main .form dl dt {
  line-height: 28px;
  font-size: 16px;
  font-weight: normal;
  color: #666;
}
.login-main .form dl dd {
  position: relative;
}
.eye {
  position: absolute;
  right: 10px;
  top: 8px;
}
.login-main .form dl dd .txt {
  height: 40px;
  width: 100%;
}
.login-main .form dl dd .txt.el-input--small {
  font-size: 16px;
}
.txt ::v-deep .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.phoneCode ::v-deep .el-input__inner {
  border-right: none;
}
::v-deep .el-input-group__append{
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #DCDFE6;
  border-left: 0 !important;
}
.primary-color { color: #0E78FD; }
.forget-pwt {
  padding: 0 0 28px 2px;
  color: #3A3F63;
}
.send-btn {
  color: #0076F6;
  text-decoration: underline;
}
::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: inherit;
}
.divider {
  position: relative;
  font-size: 14px;
  font-weight: 400;
  color: #666;
  padding-top: 10px;
  margin-bottom: 36px;
  border-bottom: solid 1px rgba(230, 232, 240, 1);
}
.divider span {
  position: absolute;
  left: 50%;
  background: #fff;
  padding: 0 30px;
  top: 0px;
  line-height: 20px;
  transform: translate(-50%);
}
.logo {
  padding-bottom: 50px;
}
</style>
